import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const InventoryTransactionViewModule = new Module({
  id: 'INVENTORY-TRANSACTION-REPORT:VIEW:*',
  name: 'Inventory Transaction',
  label: 'Inventory Transaction',
  path: 'inventory-transaction',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/InventoryTransaction'))
  ),
  actions: {
    viewDetails: {
      id: 'INVENTORY-TRANSACTION-REPORT:VIEW:DETAILS',
      name: 'view-details',
      label: 'View Details'
    }
  }
});

const InventoryTransactionModules = [InventoryTransactionViewModule];

export default new ModuleBundle(
  'InventoryTransaction',
  InventoryTransactionModules
);
